import { useTranslation } from "react-i18next";
import { CustomCard, CustomTable, RecordCards } from "../../../../../../components";
import { useMobile } from "../../../../../../context/MobileContext";
import { moneyFormat } from "../../../../../../plugins/numberFormat";
import { envChangeType, formatDate } from "../../../../../../plugins/utils";
import styles from "./style.module.scss";

const Details = ({ data, isDividend, hasNextPage, fetchNextPage, isFetchingNextPage, item }) => {
  const { t } = useTranslation();
  const { isMobile } = useMobile();

  const customColumn = () => {
    if (isDividend) {
      return {
        title: t("label.account"),
        dataIndex: "mobile",
        key: "mobile",
      };
    } else {
      return {
        title: t("label.items"),
        key: "items",
        render: () => t("user.myIncome.revenue"),
      };
    }
  };

  const columns = [
    customColumn(),
    {
      title: t("label.amount"),
      dataIndex: "buy_money",
      key: "buy_money",
      render: (dom) => moneyFormat(dom),
    },
    {
      title: t("label.time"),
      dataIndex: "createtime",
      key: "createtime",
      render: (dom) => formatDate(dom),
    },
    {
      title: t("label.income"),
      key: "money",
      dataIndex: "money",
      render: (dom) =>
        "+" +
        moneyFormat(dom) +
        " " +
        t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
    },
  ];

  const renderCardContent = (data) => {
    return (
      <>
        <div className={styles.left}>
          <div className={styles.bold}>
            {item === 0 ? t("user.myIncome.revenue") : data?.mobile}
          </div>
          <div>{formatDate(data?.createtime)}</div>
        </div>
        <div className={styles.right}>
          <div className={styles.bold}>
            {"+" +
              moneyFormat(data?.money) +
              " " +
              t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`)}
          </div>
          <div>{moneyFormat(data?.buy_money)}</div>
        </div>
      </>
    );
  };

  return isMobile ? (
    <RecordCards
      data={data}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
      isFetchingNextPage={isFetchingNextPage}
      content={renderCardContent}
    />
  ) : (
    <CustomCard title={t("user.myIncome.details")}>
      <CustomTable columns={columns} data={data} />
    </CustomCard>
  );
};

export default Details;
